var map = {
	"./actions.svg": 25760,
	"./calendar.svg": 85033,
	"./checkbox_ok.svg": 62577,
	"./clock-outline.svg": 47550,
	"./coffee-outline.svg": 85354,
	"./connect_logo_bar.svg": 94009,
	"./course.svg": 98812,
	"./document.svg": 152,
	"./download.svg": 91303,
	"./exit.svg": 43579,
	"./file.svg": 34709,
	"./home.svg": 74174,
	"./indeterminate_circle.svg": 62351,
	"./info.svg": 36947,
	"./lock.svg": 45482,
	"./magnify.svg": 23380,
	"./mdi-portrait.svg": 84643,
	"./pink_undo.svg": 8840,
	"./plus.svg": 24491,
	"./portrait.svg": 59610,
	"./professor.svg": 17578,
	"./refresh.svg": 32304,
	"./reminder.svg": 4929,
	"./settings.svg": 20716,
	"./student.svg": 82548,
	"./teacher-outline.svg": 61822,
	"./tempAvatar.svg": 11070,
	"./undo.svg": 57305,
	"./user.svg": 10698,
	"./wallet.svg": 56736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;